<template>
  <div>
    <div class="contant-wrap">
      <h4>消息</h4>
      <div class="table">
        <header>
          <div class="check">
            <el-checkbox v-model="checked" @change="checkHandle">全选</el-checkbox>
            <el-button @click="batchDelete" type="text" class="text" :disabled="this.getCheckedId().length === 0">批量删除</el-button>
            <el-button @click="batchRead" type="text" class="text" :disabled="this.getCheckedId().length === 0">标记为已读</el-button>
          </div>
          <div>共计 {{total}} 条</div>
        </header>
        <div class="body">
          <ul>
            <li v-for="item in tableData" :key="item.messageNotifyId">
              <div>
                <el-checkbox v-model="item.checked" @change="checkChildrenHandle"></el-checkbox>
                <span :class="{read: item.status !== 1}">{{ item.level | getLevel }}</span>
                <p :class="{read: item.status !== 1}" @click="toMessage(item.messageNotifyId)" class="title">{{item.messageHead}}</p>
              </div>
              <p class="fs-12">{{item.activeTime}}</p>
            </li>
          </ul>
        </div>
        <div class="pagination" v-if="tableData.length > 0">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="queryMsg.currentPage"
          :page-sizes="pageSizes"
          :page-size.sync="queryMsg.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
      </div>
    </div>
    
  </div>
</template>


<script>
import { pageSizes,pickerOptions, GENDER_OPTOINS, ORDER_TYPE_ORTIONS } from '@/config/constant';

export default {
  data() {
    return {
      checked: false,
      pageSizes: pageSizes,
      queryMsg: {
        currentPage: 1,
        pageSize: 20,
        status: null,
      },
      total: 10,
      tableData: [],
    }
  },
  methods: {
    handleSizeChange() {
      this.getMsgList();
    },
    handleCurrentChange() {
      this.getMsgList();
    },
    getMsgList() {
      this.$api.global.messageList(this.queryMsg).then((res) => {
        console.log(res);
        this.tableData = res.records.map((item) => {
          return {
            ...item,
            checked: false
          }
        });
        this.total = res.totalSize;
      })
    },
    checkHandle(e) {
      this.tableData = this.tableData.map((item) => {
        return {
          ...item,
          checked: e,
        }
      })
    },
    checkChildrenHandle(e) {
      const checkLen = this.tableData.filter(item => item.checked).length;
      if(checkLen === this.tableData.length && e) {
        this.checked = true;
      } else {
        this.checked = false;
      }
    },
    getCheckedId() {
      return this.tableData.filter(item => item.checked).map(item => item.messageNotifyId);
    },
    getCheckedDelId() {
      return this.tableData.filter(item => item.checked).map(item => {
        return {
          messageNotifyId: item.messageNotifyId,
          messageId: item.messageId,
        }
      });
    },
    batchDelete() {
      if(this.getCheckedDelId().length === 0) {
        this.$message({
          type: 'warning',
          message: '请选择一条消息！',
        })
        return;
      }
      this.$api.global.messageBatchDelete({deleteMessages: this.getCheckedId()}).then((res) => {
        this.getMsgList();
        this.$message({
          type: 'success',
          message: '删除成功！',
        })
      })
    },
    batchRead() {
      if(this.getCheckedId().length === 0) {
        this.$message({
          type: 'warning',
          message: '请选择一条消息！',
        })
        return;
      }
      this.$api.global.messageBatchUpdate({messageNotifyIdList: this.getCheckedId()}).then((res) => {
        this.getMsgList();
        this.$message({
          type: 'success',
          message: '操作成功！',
        })
      })
    },
    toMessage(id) {
      this.$router.push({name: 'messageDetail', query:{id}});
    }
  },
  mounted() {
    this.getMsgList();
  },
  filters: {
    getLevel(level) {
      return level === 0? '系统消息' : '连锁消息';
    },
  }
}
</script>

<style lang="scss" scoped>
  h4 {
    font-size: 16px;
    font-weight: bold;
  }
  .title {
    cursor: pointer;
    margin-left: 40px !important;
  }
  .fs-12 {
    font-size: 12px;
  }
  .table {
    header {
      display: flex;
      justify-content: space-between;
      color: #999999;
      border-bottom: 1px solid #CCCCCC;
      padding-bottom: 10px;
      .check {
        display: flex;
        div {
          margin-left: 60px;
          cursor: pointer;
        }
        .text {
          padding: 0 !important;
          height: 20px !important;
        }
      }
    }
    .body {
      ul {
        li {
          display: flex;
          justify-content: space-between;
          height: 70px;
          line-height: 70px;
          border-bottom: 1px solid #EEEEEE;
          color: #999999;
          .read {
            color: #333333;
          }
          div {
            p {
              display: inline-block;
              margin-left: 10px;
            }
          }
        }
      }
    }
  }
</style>